import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy } from 'secondstep-components'
import { calendarSrc } from './data'

export const ScheduleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 521px;
  padding: 0 122px;

  ${themeGet('breakpoints.mobile')} {
    padding: 38px 20px 28px;
    height: auto;
  }
`

export const ScheduleCopy = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
  text-align: center;
  margin-bottom: 33px;

  ${themeGet('breakpoints.mobile')} {
    margin-bottom: 21px;
  }
`

export const Calendar = styled.img.attrs(() => ({
  src: calendarSrc,
}))`
  width: 139px;
  margin-bottom: 33px;

  ${themeGet('breakpoints.mobile')} {
    margin-bottom: 20px;
  }
`
